<template>
	<b-modal :id="modalData.id" :visible="modalData.visible" hide-footer>
		<div slot="modal-title">{{ modalData.label }}?</div>
		<b-container class="text-center">
			<b-row>
				<b-col class="text-justify" v-html="modalData.message"></b-col>
			</b-row>
			<b-row class="my-4">
				<b-col class="text-justify">Please type in <strong>{{ modalData.confirmText }}</strong> to confirm.</b-col>
			</b-row>
			<b-row class="mx-2 my-4 align-items-center">
				<b-col class="p-0">
					<b-form-input size="sm" class="w-100 m-0 p-0 text-center" v-model="userConfirmText" type="text" :placeholder="modalData.confirmText" />
				</b-col>
				<b-col cols="2" class="p-0">
					<b-button size="sm" variant="danger" :disabled="userConfirmText !== modalData.confirmText" @click="$emit('confirmed'); $root.$emit('bv::hide::modal', modalData.id);">{{ modalData.confirmButtonText }}</b-button>
				</b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>

<script>
	export default
	{
		name: 'confirm-modal',
		props: [ 'modalData' ],
		data()
		{
			return {
				userConfirmText: undefined
			};
		}
	}
</script>
